import { createContext } from 'react';
import type { TodoWidgetDate } from '../../../types';

type TodosWidgetContextType = {
  activeKey: TodoWidgetDate;
  setActiveKey: (key: TodoWidgetDate) => void;
};

export const TodosWidgetContext = createContext<TodosWidgetContextType | undefined>(undefined);
